export default "__VITE_ASSET__MvCUTH6D__"